// extracted by mini-css-extract-plugin
export default {"welcome_screen":"welcome-screen_welcome_screen__DW4ZI","wrapper":"welcome-screen_wrapper__Un22a","inner":"welcome-screen_inner__obw7O"};